import { c as _c } from "react/compiler-runtime";
import { DesignProvider, defaultDesignValues } from '@systemeio/digital-store-shared';
import fs from 'fs';
import ContentWrapper from 'modules/stores/store/components/content-wrapper';
import StoreEditDesignButton from 'modules/stores/store/components/design/store-edit-design-button';
import PreviewBox from 'modules/stores/store/components/preview-box';
import PreviewBoxMobile from 'modules/stores/store/components/preview-box-mobile';
import StoreBreadcrumbs from 'modules/stores/store/components/store-breadcrumbs';
import StoreEditButton from 'modules/stores/store/components/store-edit-button';
import StoreViewButton from 'modules/stores/store/components/store-view-button';
import { StoreLoco } from 'modules/stores/store/constants/store-loco';
import { StoreEditItemProvider } from 'modules/stores/store/context/store-item-edit-context';
import { StorePreviewProvider } from 'modules/stores/store/context/store-preview-context';
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { NextPage } from 'next';
import { useAdaptiveStickyColomn } from 'shared/hooks/use-adaptive-sticky-colomn';
import { getBaseServerSideProps, getCombinedServerSideProps } from 'shared/utils/get-base-server-side-props';
interface StoreProps {
  css: string;
  lightLectureCss: string;
}
export const STORE_TOOLBAR_ID = 'store-toolbar';
const Store: NextPage<StoreProps> = t0 => {
  const $ = _c(31);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      indent: 20
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    adaptiveElementRef
  } = useAdaptiveStickyColomn(t1);
  const {
    storeId,
    tab
  } = useStoreQuery();
  const {
    data: storeView
  } = useStore(storeId);
  const t2 = storeView?.design ?? defaultDesignValues.default;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StoreBreadcrumbs />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <StoreViewButton />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== tab) {
    t5 = tab !== StoreTabEnum.storeSettings && <StoreEditButton />;
    $[5] = tab;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== tab) {
    t6 = tab !== StoreTabEnum.theme && <StoreEditDesignButton />;
    $[7] = tab;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== tab) {
    t7 = tab !== StoreTabEnum.theme && <PreviewBoxMobile />;
    $[9] = tab;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <div className="bg-background-primary z-sticky-override shadow-around-sm sticky top-0 -ml-5 -mr-5 -mt-5 mb-2 flex w-screen flex-wrap items-center justify-between gap-y-1 self-center p-5 py-4 sm:flex-nowrap sm:py-5 lg:static lg:m-0 lg:w-full lg:bg-transparent lg:p-0 lg:shadow-none" id={STORE_TOOLBAR_ID}>{t3}<div className="flex gap-3">{t4}{t5}{t6}{t7}</div></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <PreviewBox />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== adaptiveElementRef) {
    t10 = <div ref={adaptiveElementRef} className="sticky top-5 hidden h-[calc(100vh-170px)] max-h-[720px] min-h-[500px] lg:block">{t9}</div>;
    $[16] = adaptiveElementRef;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <StoreEditItemProvider><ContentWrapper /></StoreEditItemProvider>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = <div className="flex gap-5">{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t8) {
    t13 = <div className="flex flex-col gap-5">{t8}{t12}</div>;
    $[21] = t12;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t2) {
    t14 = <DesignProvider design={t2}>{t13}</DesignProvider>;
    $[24] = t13;
    $[25] = t2;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== props.css || $[28] !== props.lightLectureCss || $[29] !== t14) {
    t15 = <StorePreviewProvider css={props.css} lightLectureCss={props.lightLectureCss}>{t14}</StorePreviewProvider>;
    $[27] = props.css;
    $[28] = props.lightLectureCss;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export const getServerSideProps = getCombinedServerSideProps(getBaseServerSideProps(StoreLoco, 'header.top_menu.stores'), async (): Promise<{
  props: StoreProps;
}> => {
  const css = fs.readFileSync('../../node_modules/@systemeio/digital-store-shared/dist/style.css', 'utf8');
  const lightLectureCss = fs.readFileSync('../../node_modules/@systemeio/light-lecture-viewer/build/index.css', 'utf8');
  return {
    props: {
      css,
      lightLectureCss
    }
  };
});
export default Store;